import { default as Checkbox } from 'antd/es/checkbox';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { useDraftProgress } from '../contexts/DraftProgressProvider';
import { useDraftStepSubmitBus } from '../contexts/DraftStepSubmitBus';
import { useDraftStepFields } from '../hooks/useDraftStepFields';
import type { StepFormExtensionProps } from '../utils/types';

export const UltimateDebtorSameAsReceiver = ({
  step
}: StepFormExtensionProps) => {
  const { getValues } = useFormContext();
  const { onSuccessfulSubmit } = useDraftStepSubmitBus();
  const { setData } = useDraftProgress();

  const { fields: senderFields } = useDraftStepFields(step);
  const { fields: receiverFields } = useDraftStepFields('creditor');

  const [sameReceiver, setSameReceiver] = useState(false);

  const sharedFieldNames = useMemo(() => {
    return [
      ...new Set(senderFields.map((f) => f.name)).intersection(
        new Set(receiverFields.map((f) => f.name))
      )
    ];
  }, [senderFields, receiverFields]);

  const setReceiverStepValue = useCallback(
    (data: { [s: string]: unknown }) => {
      setData((prev) => ({
        ...prev,
        creditor: data
      }));
    },
    [setData]
  );

  useEffect(() => {
    return onSuccessfulSubmit(() => {
      if (sameReceiver) {
        const entries = sharedFieldNames.map((name) => [
          name,
          getValues(`${step}.${name}`)
        ]);
        setReceiverStepValue(Object.fromEntries(entries));
      }
    });
  }, [
    getValues,
    onSuccessfulSubmit,
    sameReceiver,
    setReceiverStepValue,
    sharedFieldNames,
    step
  ]);

  return (
    <div className="flex gap-2 text-sm">
      <Checkbox
        onChange={(e) => setSameReceiver(e.target.checked)}
        value={sameReceiver}
      />
      <span>Sender is the same as receiver</span>
    </div>
  );
};
